import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';

export const withMask = (Input, { format, parse }) => {
    const InputWithMask = ({ defaultValue, onChange, inputRef, ...otherProps }) => {
        const [value, setValue] = useState(format(defaultValue));
        const ref = inputRef || useRef();

        const interceptOnChange = evt => {
            const formattedValue = format(evt.target.value);
            setValue(formattedValue);
            ref.current.value = formattedValue;
            onChange(evt, { formattedValue, parsedValue: parse(formattedValue) });
        };

        return <Input inputRef={ref} value={value} onChange={interceptOnChange} {...otherProps} />;
    };

    InputWithMask.propTypes = {
        defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        inputRef: PropTypes.shape({}),
        onChange: PropTypes.func,
    };

    /* istanbul ignore next */
    InputWithMask.defaultProps = {
        defaultValue: '',
        inputRef: undefined,
        onChange: () => undefined,
    };

    return InputWithMask;
};
